(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wishlist-script"] && !Shopify.designMode) return;
  try {
    (function() {
function getWishlist() {
try {
return JSON.parse(localStorage.getItem('salini_wishlist') || '[]');
} catch (e) {
return [];
}
}
function setWishlist(list) {
try {
localStorage.setItem('salini_wishlist', JSON.stringify(list));
} catch (e) {}
}
function isWishlisted(id) {
return getWishlist().includes(String(id));
}
function updateButtonState(btn) {
var id = btn.getAttribute('data-product-id');
var active = isWishlisted(id);
btn.classList.toggle('is-active', active);
btn.setAttribute('aria-pressed', active ? 'true' : 'false');
}
function toggleWishlist(id) {
var list = getWishlist();
var idx = list.indexOf(String(id));
if (idx > -1) {
list.splice(idx, 1);
} else {
list.push(String(id));
}
setWishlist(list);
}
function handleClick(event) {
var btn = event.target.closest('[data-wishlist-toggle]');
if (!btn) return;
event.preventDefault();
event.stopPropagation();
var id = btn.getAttribute('data-product-id');
toggleWishlist(id);
document.querySelectorAll('[data-wishlist-toggle][data-product-id="' + id + '"]').forEach(updateButtonState);
}
document.addEventListener('click', handleClick);
function initAll() {
document.querySelectorAll('[data-wishlist-toggle]').forEach(updateButtonState);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initAll);
} else {
initAll();
}
document.addEventListener('shopify:section:load', initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
